function initFileTreeAccordions() {
  const triggers = document.querySelectorAll("[data-files-accordion-trigger]");

  if (!triggers.length) {
    return;
  }

  triggers.forEach((trigger) => {
    const panelId = trigger.getAttribute("aria-controls");
    const panel = document.getElementById(panelId);

    if (!panel) {
      return;
    }

    trigger.addEventListener("click", () => {
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      trigger.setAttribute("aria-expanded", String(!isExpanded));
      trigger.classList.toggle("is-open", !isExpanded);
      panel.hidden = isExpanded;
    });
  });
}

function runOnLoadAndDocumentReady() {
  initFileTreeAccordions();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runOnLoadAndDocumentReady);
} else {
  runOnLoadAndDocumentReady();
}
